import DPDropDown from "framework/components/DPDropDown";
import DPTextBox from "framework/components/DPTextBox";
import { Text } from "framework/validators/TextValidation";
import { Button, Col, Row } from "reactstrap";


const TransactionCentralUpdateContent = ({
    transactionList,
    formData,
    setFormData,
    fromLocations,
    toLocations,
    getTransactionData,
    txn_UI 
}) => {
    return (
        <>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="Select Transaction Type"
                        textType="text"
                        optionGroup={transactionList}
                        selectedGroup={formData.selectedTxn}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                selectedTxn: e.value
                            })
                        }}
                        disabled={formData.disableDocumentNo}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Transaction No"
                        textType="text"
                        maxLength="50"
                        value={formData.documentNo}
                        onChange={(e) => {

                            const validated = Text(e.target, 50, true, false, "upper", false)

                            setFormData({
                                ...formData,
                                documentNo: validated
                            })
                        }}
                        onBlur={(e) => {
                            getTransactionData(e.target.value)
                        }}
                        disabled={formData.disableDocumentNo}
                    />
                </Col>
            </Row>
            <Row hidden={formData.disableLocations}>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="From Location"
                        textType="text"
                        optionGroup={fromLocations}
                        selectedGroup={formData.fromLocation}
                        disabled={true}
                    />
                </Col>
            </Row>
            <Row hidden={formData.disableLocations}>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="To Location"
                        textType="text"
                        optionGroup={toLocations}
                        disabled={true}
                        selectedGroup={formData.toLocation}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                toLocation: e.value
                            })
                        }}
                    // disabled={disabled}
                    />
                </Col>
            </Row>
            <Row hidden={formData.disableLocations}>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText={`${txn_UI?.strTX_REF1 ?? "Reference 1"}`}
                        textType="text"
                        maxLength="25"
                        value={formData.hed_ref1}
                        onChange={(e) => {

                            if (e.target.value.length > 25) {
                                return
                            }


                            setFormData({
                                ...formData,
                                hed_ref1: e.target.value
                            })
                        }}
                    />
                </Col>
            </Row>
            <Row hidden={formData.disableLocations}>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText={`${txn_UI?.strTX_VALIDFROMDATE_CAPTION ?? "Valid From Date"}`}
                        textType="date"
                        maxLength="50"
                        value={formData.hed_validFromDate}
                        onChange={(e) => {

                            setFormData({
                                ...formData,
                                hed_validFromDate: e.target.value
                            })
                        }}
                    />
                </Col>
            </Row>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
        </>
    );
}

export default TransactionCentralUpdateContent;